import Ajax from "./ajax";

import { jsToFormData } from "@/utils/func";
// 学习记录
export const getTopicRecords = (data) => Ajax.get(`/fs-user-make-record`, data); //查询做题记录
// export const getCollectRecords = data => Ajax.get(`/fs-user-coll-list`, data); //我的收藏
// export const getCollectCourse = data => Ajax.get(`/fs-user-coll-course`, data); //我的收藏
export const getNoteRecords = () => Ajax.get(`/fs-user-qnote-course`, null); //我的笔记
export const studyRecordInfo = data => Ajax.get(`/fs-user-qnote-list`, data); //我的笔记详情
export const getErrorRecords = data => Ajax.get(`/fs-user-error-course`, data); //错题集
export const getErrorRecordsNum = data => Ajax.get(`/fs-user-error-question`, data); //错题集
export const qnoteDel = data => Ajax.post(`/fs-user-qnote-del`, jsToFormData(data)); //错题集
